/** @format */

import { Auth } from '../modules/auth/Auth';
import { notificationConstants } from '../modules/notifications/notifications';
import { debug } from '../core/debug';
import { configDefault } from '../core/config';
// const _ = require('underscore');

export const FormGeneralHelper = {
    ERROR: 'error',
    SUCCESS: 'success',

    TYPE_TEXT: 'text',
    TYPE_CHECBOX: 'checkbox',
    TYPE_NIP: 'nip',
    TYPE_PESEL: 'pesel',
    TYPE_REGON: 'regon',
    TYPE_NUMBER: 'number',
    TYPE_NUMBER_EXT: 'number_ext',
    TYPE_NUMBER_EXT_INTEGER: 'number_ext_integer',
    TYPE_NUMBER_AS_STRING: 'text',
    TYPE_ZIP: 'zip',
    TYPE_EMAIL: 'email',
    TYPE_PASSWORD: 'password',
    TYPE_RPT: 'rpt',

    /**
     * hotfix
     * @param iri
     * @returns {*}
     */
    changeAdescomApiIriToBaseApiIri: (iri) => {
        return iri.replace('adescom-api', 'base-api');
    },

    /**
     * Returns UI URI. i.e. /admin/{routeName}
     * @param {string} routeName UI route
     * @returns {string} /admin/{routeName}
     */
    getRouteUrl: (routeName) => {
        return process.env.REACT_APP_ROUTE_NAME + routeName;
    },

    /**
     * Returns API URI. i.e. /adescom-api/api/{apiPrefix}/{apiName}
     * @param {string} apiName API entity name i.e. /platform_resellers
     * @param {string} apiPrefix API namespace i.e. platform|crm
     * @returns {string} /adescom-api/api/{apiPrefix}/{apiName}
     */
    getPath: (apiName, apiPrefix = 'platform') => {
        switch (apiPrefix) {
            case configDefault.PLATFORM_API_PREFIX:
            case configDefault.ES_API_PREFIX:
                break;
            default:
                return null;
        }
        return window._ROOT_MAIN_PATH + '/' + apiPrefix + apiName;
    },

    /**
     * Returns FULL API URL. i.e. http://127.0.0.1/adescom-api/api/{apiPrefix}/{apiName}
     * @param {string} apiName API entity name i.e. /platform_resellers
     * @param {string} apiPrefix API namespace i.e. platform|crm
     * @returns {string} http://127.0.0.1/adescom-api/api/{apiPrefix}/{apiName}
     */
    getUrl: (apiName, apiPrefix = 'platform') => {
        return window._ROOT_DATA_PROVIDER + FormGeneralHelper.getPath(apiName, apiPrefix);
    },

    /**
     * Returns FULL API URL. i.e. http://127.0.0.1{uri}
     * @param {string} uri Full api Uri as in /api/platform/platform_resellers
     * @returns {string} Returns FULL API URL. i.e. http://127.0.0.1{uri}
     */
    getByUri: (uri) => {
        return window._ROOT_DATA_PROVIDER + uri;
    },

    verifyEmail: (value) => {
        const emailRex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return emailRex.test(value);
    },

    verifyMinLength: (value, length) => {
        if (length === -1) {
            return true;
        }
        return value.length > length;
    },

    verifyMaxLength: (value, length) => {
        if (length === -1) {
            return true;
        }
        return value.length < length;
    },

    verifyEqual: (value, length) => {
        return value.length === length;
    },

    compare: (string1, string2) => {
        return string1 === string2;
    },

    verifyNumber: (value) => {
        const numberRex = new RegExp('^[0-9]+$');
        return numberRex.test(value);
    },

    verifyIntegerNumber: (value) => {
        const numberRex = new RegExp('^[0-9-]+$');
        return numberRex.test(value);
    },

    verifyZipCodePl: (value) => {
        const numberRex = new RegExp('^[0-9]{2}-[0-9]{3}$');
        return numberRex.test(value);
    },

    fileDownloadUrl: (url = '/adescom-api/api/download_file', type, query = '', options = {}) => {
        const token = Auth.getAccessToken();
        const { processUrl = false } = options;

        let outputUrl = url;

        if (processUrl) {
            outputUrl = FormGeneralHelper.getByUri(url);
        }

        const requestUrl = `/${type}/${token}/${query}`.replace(/\/\//g, '/');

        return `${outputUrl}${requestUrl}`;
    },

    isRequiredTextField: (require, value) => {
        if (require === false) {
            return true;
        }

        if (!value && require) {
            return true;
        }
        return FormGeneralHelper.verifyMinLength(value, 0);
    },

    validateFormsHook: (
        entity,
        setEntityCallback,
        entityStatus,
        setEntityStatusCallback,
        event,
        stateName,
        type,
        require,
        maxValue,
        minValue,
        callback,
        callbackStatus,
        nullable
    ) => {
        const value = event.target.value;
        let state = FormGeneralHelper.ERROR;

        if (FormGeneralHelper.isRequiredTextField(require, value)) {
            switch (type) {
                case FormGeneralHelper.TYPE_NIP:
                    if (FormGeneralHelper.verifyNumber(value) && FormGeneralHelper.verifyEqual(value, maxValue)) {
                        state = FormGeneralHelper.SUCCESS;
                    }
                    break;
                case FormGeneralHelper.TYPE_PESEL:
                    if (FormGeneralHelper.verifyNumber(value) && FormGeneralHelper.verifyEqual(value, maxValue)) {
                        state = FormGeneralHelper.SUCCESS;
                    }
                    break;
                case FormGeneralHelper.TYPE_REGON:
                    if (
                        FormGeneralHelper.verifyNumber(value) &&
                        FormGeneralHelper.verifyMinLength(value, minValue) &&
                        FormGeneralHelper.verifyMaxLength(value, maxValue)
                    ) {
                        state = FormGeneralHelper.SUCCESS;
                    }
                    break;
                case FormGeneralHelper.TYPE_TEXT:
                    if (nullable && value === null) {
                        state = FormGeneralHelper.SUCCESS;
                        break;
                    }
                    if (FormGeneralHelper.verifyMaxLength(value, maxValue) && FormGeneralHelper.verifyMinLength(value, minValue)) {
                        state = FormGeneralHelper.SUCCESS;
                    }
                    break;
                case FormGeneralHelper.TYPE_EMAIL:
                    if ((FormGeneralHelper.verifyMaxLength(value, maxValue) && FormGeneralHelper.verifyEmail(value)) || value.length === 0) {
                        state = FormGeneralHelper.SUCCESS;
                    }
                    break;
                case FormGeneralHelper.TYPE_ZIP:
                    if (FormGeneralHelper.verifyZipCodePl(value) || value.length === 0) {
                        state = FormGeneralHelper.SUCCESS;
                    }
                    break;
                case FormGeneralHelper.TYPE_NUMBER:
                case FormGeneralHelper.TYPE_NUMBER_EXT:
                case FormGeneralHelper.TYPE_NUMBER_AS_STRING:
                    if (
                        (!require && !value) ||
                        (FormGeneralHelper.verifyNumber(value) && parseInt(value) <= maxValue && parseInt(value) >= minValue)
                    ) {
                        state = FormGeneralHelper.SUCCESS;
                    }
                    break;
                case FormGeneralHelper.TYPE_NUMBER_EXT_INTEGER:
                    if ((!require && !value) || FormGeneralHelper.verifyIntegerNumber(value)) {
                        state = FormGeneralHelper.SUCCESS;
                    }
                    break;
                case FormGeneralHelper.TYPE_PASSWORD:
                    state = FormGeneralHelper.SUCCESS;
                    break;
                case FormGeneralHelper.TYPE_RPT:
                    if (value.length === 5) {
                        state = FormGeneralHelper.SUCCESS;
                    }
                    break;
                default:
                    if (value.length === 0) {
                        state = FormGeneralHelper.SUCCESS;
                    }
                    debug('No validator!');
                    break;
            }
        }
        const tmpEntityStatus = entityStatus;
        tmpEntityStatus[stateName] = state;
        setEntityStatusCallback(tmpEntityStatus);

        const tmpEntity = entity;
        switch (type) {
            case FormGeneralHelper.TYPE_CHECBOX:
                tmpEntity[stateName] = event.target.checked;
                break;
            case FormGeneralHelper.TYPE_NUMBER_EXT:
            case FormGeneralHelper.TYPE_NUMBER_EXT_INTEGER:
                tmpEntity[stateName] = parseInt(value);
                break;
            default:
                tmpEntity[stateName] = value;
                break;
        }

        setEntityCallback(tmpEntity);

        if (callback) {
            callback();
        }
    },

    validateForms: (component, event, stateName, type, require, maxValue, minValue, callBack, callBackStatus, nullable) => {
        const value = event.target.value;
        let state = FormGeneralHelper.ERROR;
        if (FormGeneralHelper.isRequiredTextField(require, value)) {
            switch (type) {
                case FormGeneralHelper.TYPE_NIP:
                    if (FormGeneralHelper.verifyNumber(value) && FormGeneralHelper.verifyEqual(value, maxValue)) {
                        state = FormGeneralHelper.SUCCESS;
                    }
                    break;
                case FormGeneralHelper.TYPE_PESEL:
                    if (FormGeneralHelper.verifyNumber(value) && FormGeneralHelper.verifyEqual(value, maxValue)) {
                        state = FormGeneralHelper.SUCCESS;
                    }
                    break;
                case FormGeneralHelper.TYPE_REGON:
                    if (
                        FormGeneralHelper.verifyNumber(value) &&
                        FormGeneralHelper.verifyMinLength(value, minValue) &&
                        FormGeneralHelper.verifyMaxLength(value, maxValue)
                    ) {
                        state = FormGeneralHelper.SUCCESS;
                    }
                    break;
                case FormGeneralHelper.TYPE_TEXT:
                    if (nullable && value === null) {
                        state = FormGeneralHelper.SUCCESS;
                        break;
                    }
                    if (FormGeneralHelper.verifyMaxLength(value, maxValue) && FormGeneralHelper.verifyMinLength(value, minValue)) {
                        state = FormGeneralHelper.SUCCESS;
                    }
                    break;
                case FormGeneralHelper.TYPE_EMAIL:
                    if ((FormGeneralHelper.verifyMaxLength(value, maxValue) && FormGeneralHelper.verifyEmail(value)) || value.length === 0) {
                        state = FormGeneralHelper.SUCCESS;
                    }
                    break;
                case FormGeneralHelper.TYPE_ZIP:
                    if (FormGeneralHelper.verifyZipCodePl(value) || value.length === 0) {
                        state = FormGeneralHelper.SUCCESS;
                    }
                    break;
                case FormGeneralHelper.TYPE_NUMBER:
                case FormGeneralHelper.TYPE_NUMBER_EXT:
                case FormGeneralHelper.TYPE_NUMBER_AS_STRING:
                    if (FormGeneralHelper.verifyNumber(value) || value.length === 0) {
                        state = FormGeneralHelper.SUCCESS;
                    }
                    break;
                case FormGeneralHelper.TYPE_NUMBER_EXT_INTEGER:
                    if (FormGeneralHelper.verifyIntegerNumber(value) || value.length === 0) {
                        state = FormGeneralHelper.SUCCESS;
                    }
                    break;
                case FormGeneralHelper.TYPE_PASSWORD:
                    state = FormGeneralHelper.SUCCESS;
                    break;
                default:
                    if (value.length === 0) {
                        state = FormGeneralHelper.SUCCESS;
                    }
                    debug('No validator!');
                    break;
            }
        }

        component.setState(
            (prevState) => ({
                entityStatus: {
                    ...prevState.entityStatus,
                    [stateName]: state,
                },
            }),
            callBackStatus
        );

        switch (type) {
            case FormGeneralHelper.TYPE_CHECBOX:
                component.setState(
                    (prevState) => ({
                        entity: {
                            ...prevState.entity,
                            [stateName]: event.target.checked,
                        },
                    }),
                    callBack
                );
                break;
            default:
                component.setState(
                    (prevState) => ({
                        entity: {
                            ...prevState.entity,
                            [stateName]: value,
                        },
                    }),
                    callBack
                );
                break;
        }
    },

    validateOnSubmit: (state) => {
        for (const property in state) {
            if (state[property] === FormGeneralHelper.ERROR) {
                return false;
            }
        }
        return true;
    },

    selectFuncHook: (entity, setEntityCallback, entityStatus, setEntityStatusCallback, event, stateName, require, callback) => {
        const value = event.target.value;
        if (FormGeneralHelper.verifyNumber(value) && value > 0) {
            const tmpEntity = entity;
            tmpEntity[stateName] = value;
            setEntityCallback(tmpEntity);

            const tmpEntityStatus = entityStatus;
            tmpEntityStatus[stateName] = null;
            setEntityStatusCallback(tmpEntityStatus);

            if (callback) {
                callback();
            }
            return;
        }
        const tmpEntityStatus = entityStatus;
        tmpEntityStatus[stateName] = FormGeneralHelper.ERROR;
        setEntityStatusCallback(tmpEntityStatus);
    },

    selectFunc: (component, event, stateName, require, callback) => {
        const value = event.target.value;
        if (FormGeneralHelper.verifyNumber(value) && value > 0) {
            component.setState(
                (prevState) => ({
                    entity: {
                        ...prevState.entity,
                        [stateName]: value,
                    },
                    entityStatus: {
                        ...prevState.entityStatus,
                        [stateName]: null,
                    },
                }),
                () => {
                    if (callback) {
                        callback();
                    }
                }
            );
            return;
        }
        component.setState((prevState) => ({
            entityStatus: {
                ...prevState.entityStatus,
                [stateName]: FormGeneralHelper.ERROR,
            },
        }));
    },

    selectFuncExt: (component, event, stateName, require, callback) => {
        const value = event.target.value;
        if (value && value.length > 0) {
            component.setState(
                (prevState) => ({
                    entity: {
                        ...prevState.entity,
                        [stateName]: value,
                    },
                    entityStatus: {
                        ...prevState.entityStatus,
                        [stateName]: null,
                    },
                }),
                () => {
                    if (callback) {
                        callback();
                    }
                }
            );
            return;
        }
        component.setState((prevState) => ({
            entityStatus: {
                ...prevState.entityStatus,
                [stateName]: FormGeneralHelper.ERROR,
            },
        }));
    },

    handleSubmit: (component, event, callbackDispatch, injectResellerId, dispatch) => {
        if (event) {
            event.preventDefault();
        }
        component.setState({ success: false }, () => {
            if (FormGeneralHelper.validateOnSubmit(component.state.entityStatus)) {
                component.setState((prevState) => get(injectResellerId, prevState), callbackDispatch);
            } else if (dispatch) {
                dispatch({
                    type: notificationConstants.SUBMIT_ERROR,
                    error: 'general:common.validate_form_error',
                });
            } else {
                component.setState({
                    snackBarStatus: true,
                    snackBarMessage: 'general:common.validate_form_error',
                    snackBarVariant: 'error',
                });
            }
        });

        function get(injectResellerId, prevState) {
            if (injectResellerId) {
                return {
                    entity: {
                        ...prevState.entity,
                        platformResellerId: Auth.getUserPlatformResellerId(),
                    },
                };
            }
            return {
                entity: { ...prevState.entity },
            };
        }
    },

    handleCheckBox: (component, status, stateName) => {
        component.setState((prevState) => ({
            entity: {
                ...prevState.entity,
                [stateName]: status,
            },
        }));
    },

    verifyInputFields: (type, value, minValue, maxValue, required) => {
        const errors = [];
        if (FormGeneralHelper.isRequiredTextField(required, value)) {
            switch (type) {
                case FormGeneralHelper.TYPE_NIP:
                    if (!FormGeneralHelper.verifyEqual(value, maxValue) || !FormGeneralHelper.verifyNumber(value)) {
                        errors.push('error:form.not_a_nip');
                    }
                    break;
                case FormGeneralHelper.TYPE_PESEL:
                    if (!FormGeneralHelper.verifyNumber(value) || !FormGeneralHelper.verifyEqual(value, maxValue)) {
                        errors.push('error:form.not_a_pesel');
                    }
                    break;
                case FormGeneralHelper.TYPE_REGON:
                    if (
                        !FormGeneralHelper.verifyNumber(value) ||
                        !FormGeneralHelper.verifyMinLength(value, minValue) ||
                        !FormGeneralHelper.verifyMaxLength(value, maxValue)
                    ) {
                        errors.push('error:form.not_a_regon');
                    }
                    break;
                case FormGeneralHelper.TYPE_TEXT:
                    if (!FormGeneralHelper.verifyMaxLength(value, maxValue)) {
                        errors.push('error:form.too_long');
                    }

                    if (!FormGeneralHelper.verifyMinLength(value, minValue)) {
                        errors.push('error:form.too_short');
                    }
                    break;
                case FormGeneralHelper.TYPE_EMAIL:
                    if (!FormGeneralHelper.verifyMaxLength(value, maxValue)) {
                        errors.push('error:form.too_long');
                    }
                    if (!FormGeneralHelper.verifyEmail(value) || value.length === 0) {
                        errors.push('error:form.not_a_email');
                    }
                    break;
                case FormGeneralHelper.TYPE_ZIP:
                    if (!FormGeneralHelper.verifyZipCodePl(value) && value.length === 0) {
                        errors.push('error:form.not_a_zip_code');
                    }
                    break;
                case FormGeneralHelper.TYPE_NUMBER:
                case FormGeneralHelper.TYPE_NUMBER_AS_STRING:
                    if (parseInt(value) > maxValue) {
                        errors.push('error:form.too_high');
                    }
                    if (parseInt(value) < minValue) {
                        errors.push('error:form.too_small');
                    }
                    if ((required && !value) || (required && !FormGeneralHelper.verifyNumber(value))) {
                        errors.push('error:form.not_a_number');
                    }
                    break;
                case FormGeneralHelper.TYPE_NUMBER_EXT_INTEGER:
                    if (parseInt(value) > maxValue) {
                        errors.push('error:form.too_high');
                    }
                    if (parseInt(value) < minValue) {
                        errors.push('error:form.too_small');
                    }
                    if ((required && !value) || (required && !FormGeneralHelper.verifyIntegerNumber(value))) {
                        errors.push('error:form.not_a_number');
                    }
                    break;
                case FormGeneralHelper.TYPE_RPT:
                    if (!FormGeneralHelper.verifyMaxLength(value, maxValue) || !FormGeneralHelper.verifyMinLength(value, minValue)) {
                        errors.push('error:form.not_a_rpt');
                    }
                    break;
                default:
                    break;
            }
        }
        return errors;
    },
};
